export const GENERATION_CHANGED = "ondit:generation-changed";
const KEY = "ondit.current-generations";
let current = new Set<string>();

export function trackedGenerations(): Set<string> {
	try {
		const saved: unknown = JSON.parse(sessionStorage.getItem(KEY) ?? "[]");
		if (Array.isArray(saved)) current = new Set(saved.filter((id): id is string => typeof id === "string"));
	} catch {
		// Keep feedback usable when browser storage is unavailable.
	}
	return new Set(current);
}

export function trackGeneration(id: string, track = true) {
	current = trackedGenerations();
	const changed = current.has(id) !== track;
	if (track) current.add(id);
	else current.delete(id);
	current = new Set([...current].slice(-128));
	try {
		sessionStorage.setItem(KEY, JSON.stringify([...current]));
	} catch {
		// In-memory tracking lasts until the tab is reloaded.
	}
	if (changed) window.dispatchEvent(new Event(GENERATION_CHANGED));
}
